import React from 'react'

const PageContainer = ({children}: {children: React.ReactNode}) => {
    return (
        <div className="flex min-h-screen flex-1 flex-col bg-yellow-40">
            {children}
        </div>
    )
}

export default PageContainer
